import { isEditableAfterSubmit, type ReferralStatus } from '@hv/shared';

export type ReferralCardActionId = 'view' | 'continue' | 'edit' | 'delete';

export interface ReferralCardAction {
  id: ReferralCardActionId;
  label: string;
  to?: string;
  editRelated: boolean;
}

export const editReferralPath = (id: string) => `/my-referrals/${id}?edit=1`;

export function referralCardActions(r: { id: string; status: ReferralStatus }): ReferralCardAction[] {
  const page = `/my-referrals/${r.id}`;
  if (r.status === 'draft')
    return [
      { id: 'continue', label: 'Continue', to: page, editRelated: true },
      { id: 'delete', label: 'Delete draft', editRelated: false },
    ];
  const view: ReferralCardAction = { id: 'view', label: 'View', to: page, editRelated: false };
  if (!isEditableAfterSubmit(r.status)) return [view];
  return [
    view,
    r.status === 'needs_clarification'
      ? { id: 'continue', label: 'Continue', to: page, editRelated: true }
      : { id: 'edit', label: 'Edit', to: editReferralPath(r.id), editRelated: true },
  ];
}
